var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showContainer)?_c('div',{staticClass:"d-flex justify-content-center",attrs:{"id":'markup-container-heat-' + _vm.index}},[_c('heatmapjs-vue',{ref:'markup-plugin-' + _vm.index,staticClass:"heatmapjs-container",style:(_vm.computedStyle),attrs:{"max":100,"min":0,"data":_vm.pinData}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }